// @flow

import React from 'react'
import { Route, BrowserRouter } from 'react-router-dom'
import {
  createGenerateClassName,
  StylesProvider
} from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'
import { components } from '@peachjar/components'
import { Dimmer, Loader } from 'semantic-ui-react'
import Loadable from 'react-loadable'
import PageNotFound from 'screens/PageNotFound'
import { css } from 'emotion'
import { Provider } from 'react-redux'
import store from './store'

const makeLoadable = opts =>
  Loadable({
    loading: function DimmerLoader() {
      return (
        <Dimmer>
          <Loader />
        </Dimmer>
      )
    },
    ...opts
  })

const LoadableFlyers = makeLoadable({
  loader: () => import('./screens/Flyers')
})

const generateClassName = createGenerateClassName({
  productionPrefix: 'parent-app'
})

const { NotificationContainer: NotificationRoot } = components.Notifications

const App = () => (
  <div className={styles.root}>
    <Provider store={store}>
      <BrowserRouter>
        <StylesProvider generateClassName={generateClassName}>
          <CssBaseline />
          <NotificationRoot />
          <Route path="/" exact render={() => <PageNotFound />} />
          <Route path="/index.html" exact render={() => <PageNotFound />} />
          <Route path="/flyers" component={LoadableFlyers} />
        </StylesProvider>
      </BrowserRouter>
    </Provider>
  </div>
)
const styles = {
  root: css`
    & .notifyerror {
      min-width: 1000px;
      margin-top: 20px;
    }
    @media (max-width: 768px) {
      & .notifyerror {
        min-width: 340px;
        margin-top: 20px;
      }
    }
  `
}

export default App



// WEBPACK FOOTER //
// ./src/App.js